import { apiCall } from '@shared/entity';
import { axiosInstance } from '@libs/axios/axios';
import { PricingCalculator } from './components/MonthlyTrendChart';
import { CreatePricingCalculatorInput } from '@pages/price-calculator';

export const pricingCalculatorApi = {
  getAll: () => '/api/pricing-calculator',
  getCurrent: (month?: string) =>
    `/api/pricing-calculator/current${month ? `?month=${month}` : ''}`,
};

export const createOrUpdatePricingCalculator = async (
  data: CreatePricingCalculatorInput,
): Promise<PricingCalculator> =>
  apiCall(
    async () => await axiosInstance.post(pricingCalculatorApi.getAll(), data),
    'api.pricing.saveError',
  );

export const getCurrentPricingCalculator = async (month?: Date): Promise<PricingCalculator> => {
  const monthParam = month ? month.toISOString().slice(0, 7) : undefined;
  return apiCall(
    async () => await axiosInstance.get(pricingCalculatorApi.getCurrent(monthParam)),
    'api.pricing.notFound',
  );
};

export const getAllPricingCalculators = async (): Promise<PricingCalculator[]> =>
  apiCall(
    async () => await axiosInstance.get(pricingCalculatorApi.getAll()),
    'api.pricing.listNotFound',
  );
